<template>
  <TitleCard :title="titleCard" :showMore="showMore">
    <div class="backStack-table-wrap">
      <div class="statisticTop">
        <div>
          <span>时间范围: </span>
          <a-range-picker
            :placeholder="['开始月份', '结束月份']"
            format="YYYY-MM"
            :value="value"
            :mode="mode2"
            @panelChange="handlePanelChange2"
            @change="handleChange"
          />
        </div>
        <div class="btnClass">
          <a-button type="primary" @click="statisticClick" class="btn"
            >统计</a-button
          >
          <a-button @click="resetClick" class="btn">重置</a-button>
        </div>
      </div>
      <div></div>
      <div class="chart-main" ref="chartInstance"></div>
    </div>
  </TitleCard>
</template>

<script>
import mixinsBackStack from '@/views/backstageSupport/mixins'
import { monthsCount } from '@/api/systemUser'
import moment from 'moment'
export default {
  mixins: [mixinsBackStack],

  data() {
    return {
      tableValue: [],
      titleCard: '信息发布统计',
      chartInstance: null,
      params: {},
      xData: [],
      yData: [],
      mode2: ['month', 'month'],
      value: []
    }
  },
  components: {},
  mounted() {
    this.getCounts()
    window.addEventListener('resize', () => this.resizeChart())
  },
  methods: {
    handleChange(value) {
      this.value = value
    },
    handlePanelChange1(value, mode) {
      this.mode1 = mode
    },
    handlePanelChange2(value, mode) {
      this.params.day1 = moment(value[0]._d).format('YYYY-MM')
      this.params.day2 = moment(value[1]._d).format('YYYY-MM')
      this.value = value
      this.mode2 = [
        mode[0] === 'date' ? 'month' : mode[0],
        mode[1] === 'date' ? 'month' : mode[1]
      ]
    },
    async getCounts() {
      this.xData = []
      this.yData = []

      const { data, code } = await monthsCount(this.params, this.params)
      if (code === 200) {
        let { dataInfo } = data
        dataInfo.forEach(item => {
          if (this.xData.every(ele => ele !== item.data)) {
            this.xData.push(item.data)
          }
          this.yData.push(item.dateCount)
          this.count = data.count
        })
      }
      this.getChart()
    },
    getChart() {
      if (this.chartInstance) {
        this.chartInstance.dispose()
      }
      this.chartInstance = this.$echarts.init(this.$refs.chartInstance)
      let option = {
        title: {
          text: '访客总量: ' + this.count + '个',
          left: 'center',
          textStyle: {
            fontSize: 14,
            color: '#666',
            fontStyle: 'normal',
            fontWeight: 'normal'
          }
        },
        legend: {
          right: '120'
        },
        tooltip: {
          textStyle: {
            align: 'left'
          }
        },
        toolbox: {
          feature: {
            dataZoom: {
              yAxisIndex: 'none'
            },
            restore: {},
            saveAsImage: {
              name: '用户统计'
            }
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },

        xAxis: [
          {
            type: 'category',
            data: this.xData,
            axisTick: {
              alignWithLabel: true
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '单位:个',
            axisLine: {
              show: true,
              lineStyle: {
                color: '#666'
              }
            }
          }
        ],
        series: [
          {
            name: '访客量',
            type: 'line',
            barWidth: '50',
            itemStyle: {
              color: '#1890ff'
            },
            label: {
              show: true,
              position: 'top'
            },
            data: this.yData
          }
        ]
      }
      this.chartInstance.setOption(option)
      // 下面的是自适应屏幕大小去缩放
      this.$nextTick(() => {
        setTimeout(() => this.resizeChart(), 500)
      })
    },

    statisticClick() {
      this.getCounts()
    },
    resetClick() {
      this.value = []
      this.params = {}
      this.getCounts()
    },
    resizeChart() {
      this.chartInstance.resize()
    }
  },
  beforeDestroy() {
    // eslint-disable-next-line no-unused-expressions
    this.chartInstance && this.chartInstance.dispose()
  }
}
</script>
<style lang="scss" scoped>
.statisticTop {
  width: 100%;
  display: flex;
  margin: 20px;
  .btnClass {
    margin-left: 20px;
    .btn {
      margin-left: 10px;
    }
  }
}
.chart-main {
  width: 100%;
  height: 50vh;
}
</style>
